import React, { useState, useMemo, createContext } from 'react';
import { createPortal } from 'react-dom';
import Toast, { ToastType } from './Toast';
import { getUniqueId } from '../../utilities/helpers/common';
import { TChildren } from '../../typings/common';
import styles from './Toast.module.scss';

interface Context {
  open: (content: string, type?: ToastType, duration?: number) => void;
}

export const ToastContext = createContext<Context>({
  open: () => {},
});

interface IToast {
  id: string;
  content: string;
  type: ToastType;
  duration?: number;
}

interface Props {
  children: TChildren;
}

const ToastProvider: React.FC<Props> = ({ children }) => {
  const [toasts, setToasts] = useState<IToast[]>([]);

  const open = (
    content: string,
    type: ToastType = ToastType.SUCCESS,
    duration?: number
  ) =>
    setToasts((currentToasts) => [
      ...currentToasts,
      { id: getUniqueId(), content, type, duration },
    ]);

  const close = (id: string) =>
    setToasts((currentToasts) =>
      currentToasts.filter((toast) => toast.id !== id)
    );
  const contextValue = useMemo(() => ({ open }), []);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}

      {createPortal(
        <div className={styles.wrapper}>
          {toasts.map((toast) => (
            <Toast
              key={toast.id}
              close={() => close(toast.id)}
              type={toast.type}
              duration={toast.duration}>
              {toast.content}
            </Toast>
          ))}
        </div>,
        document.querySelector('#root')!
      )}
    </ToastContext.Provider>
  );
};

export default ToastProvider;
